<template>
  <nav class="flex flex-col">
      <div class="px-5 py-5">
          <img src='@/assets/logo-n/logo.png'
            srcset="@/assets/logo-n/logo.png 1x,
                    @/assets/logo-n/logo@2x.png 2x,
                    @/assets/logo-n/logo@3x.png 3x,
                    @/assets/logo-n/logo@4x.png 4x"
            class="h-5 laptop:h-10"
                    />
      </div>
    <div class="hidden px-5 pt-6">
        <p>Welcome</p>
        <router-link to=''>Asad A</router-link>
    </div>
    <div id="nav" class="flex flex-col pt-6">
        <!-- TODO: navigation should come from vuex and depending on user role -->
        <router-link class="menu-item text-center laptop:text-left"
        :to="{name: 'appointment.index'}">
            <i class="fa fa-chart-line pr-3"></i>
            <span class="hidden laptop:inline">Insights</span>
        </router-link>

        <router-link class="menu-item text-center laptop:text-left"
        :to="{name: 'deliveries.index'}">
            <i class="fa fa-address-book pr-3"></i>
            <span  class="hidden laptop:inline">Contacts</span>
        </router-link>

        <router-link class="menu-item text-center laptop:text-left"
        :to="{name: 'members.index'}">
            <i class="fa fa-phone pr-3"></i>
            <span  class="hidden laptop:inline ">Numbers</span>
        </router-link>

        <router-link class="menu-item text-center laptop:text-left"
        :to="{name: 'sms.index'}">
            <i class="fas fa-sms pr-3"></i>
            <span  class="hidden laptop:inline">Sms</span>
        </router-link>

        <router-link class="menu-item text-center laptop:text-left"
        :to="{name: 'settings.index'}">
            <i class="fas fa-cog pr-3"></i>
            <span  class="hidden laptop:inline">Settings</span>
        </router-link>
    </div>
  </nav>
</template>

<script>
export default {
    name: 'Navigation'
}
</script>


<style lang="scss" scoped>
.menu-item {
    @apply pl-5 py-2 font-nunito text-lg text-grey-light;
}

#nav .active {
    @apply text-blue;
}
</style>
